export default {"src":"/_next/static/media/clearpay.64031b02.svg","height":119,"width":639};